module.exports = __webpack_public_path__ + "static/media/off-white-textured.e0890dcd.jpg";